import { FC } from 'react';
import styles from './JKImage.css';

export const JKImage: FC = () => (
  <div className={styles['card-image']}>
    <div className={styles['rectangle-container']}>
      <div className={styles['rectangle']} />
      <span className={styles['rectangle-text']}>80</span>
    </div>
    <div className={styles['rectangle-container']}>
      <div className={styles['rectangle']} />
      <span className={styles['rectangle-text']}>120</span>
    </div>
    <div className={styles['rectangle-container']}>
      <div className={styles['rectangle']} />
      <span className={styles['rectangle-text']}>150</span>
    </div>
  </div>
);
